import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.list = action.payload;
    },

    resetNotifications: () => initialState,
  },
});

export const {
  setNotifications,

  resetNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
